/**
 * Seedance @-mention token 工具（移植自 vidsoda mentions.ts）。
 *
 * 提示词里的素材引用统一使用 `@image1` / `@video1` / `@audio1`（小写、无空格），
 * 与素材缩略图角标一致。旧格式 `[Image 1]` 与 `@Image 1` 等写法在归一化时
 * 全部转换为规范 token。
 */

export type MentionFormat = 'image' | 'video' | 'audio';

export interface MentionAsset {
  url: string;
  format: MentionFormat;
}

// 同时兼容 @image1 / @Image 1 与旧的 [Image 1] 写法
const MENTION_SOURCE = '@(image|video|audio)[ ]?(\\d+)|\\[(image|video|audio)[ ]*(\\d+)\\]';

export function mentionToken(format: MentionFormat, n: number): string {
  return `@${format}${n}`;
}

export function normalizeMentions(text: string): string {
  return text.replace(
    new RegExp(MENTION_SOURCE, 'gi'),
    (_m, t1, n1, t2, n2) =>
      mentionToken(String(t1 ?? t2).toLowerCase() as MentionFormat, Number(n1 ?? n2)),
  );
}

export type MentionSegment =
  | { type: 'text'; value: string }
  | { type: 'mention'; token: string };

/** 把文本切成 文本段 / mention 段，mention 段输出规范 token */
export function splitByMentions(text: string): MentionSegment[] {
  const re = new RegExp(MENTION_SOURCE, 'gi');
  const segments: MentionSegment[] = [];
  let last = 0;
  let m = re.exec(text);
  while (m) {
    if (m.index > last) {
      segments.push({ type: 'text', value: text.slice(last, m.index) });
    }
    segments.push({
      type: 'mention',
      token: mentionToken(String(m[1] ?? m[3]).toLowerCase() as MentionFormat, Number(m[2] ?? m[4])),
    });
    last = m.index + m[0].length;
    m = re.exec(text);
  }
  if (last < text.length) {
    segments.push({ type: 'text', value: text.slice(last) });
  }
  return segments;
}
